import State from "models/state"
import {connect} from "react-redux"

export const mapStateToProps = (state: State) => {
    const {template} = state

    return {
        template,
    }
}

export default connect(mapStateToProps)
